import React, { useState } from "react";
import Sidebar from "../Sidebar/sidebar";
import { RxHamburgerMenu } from "react-icons/rx";
import { Drawer } from "antd";
import "./header.scss";

const Header = ({ title }) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("left");

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="header">
        <div className="header-left">
          <div className="mobile-menu" onClick={showDrawer}>
            <RxHamburgerMenu style={{ fontSize: "35px" }} />
          </div>
          <h1>{title}</h1>
        </div>
      </div>
      <Drawer
        placement={placement}
        closable={false}
        onClose={onClose}
        open={open}
        key={placement}
        width="50%"
      >
        <Sidebar open={open} />
      </Drawer>
    </>
  );
};

export default Header;
